// extracted by mini-css-extract-plugin
export default {"flowWrapper":"FlowCanvas_flowWrapper__DzAnz"};